// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "spa/css/" + {"637":"job-search","717":"jobs-page"}[chunkId] + "." + {"637":"84a8d688","717":"f621f065"}[chunkId] + ".css";
};